import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import QuestionSelector from './QuestionSelector';
import LocalizationPanel, { LocalizationChangeHandler } from './LocalizationContainer';
import { TargetNode } from '../../models/TargetNode';


interface QuestionPanelOwnProps {
  node: TargetNode;
  // Takes either a picked option or a raw string (a free-text question).
  onChangeQuestion: (question: any) => void;
  // Index 0 of the question array is the main question itself.
  questionLocalizationChanged: LocalizationChangeHandler;
  // Lets the respondent skip answering (extra.c.c48).
  skipButton: boolean;
  onToggleSkipButton: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectorClassName?: string;
}

const QuestionPanel = ({
  node, onChangeQuestion, questionLocalizationChanged,
  skipButton, onToggleSkipButton, selectorClassName, t,
}: QuestionPanelOwnProps & WithTranslation) => (
  <fieldset>
    <legend>{t('target.editor.label.question')}</legend>
    <QuestionSelector
      className={selectorClassName}
      node={node}
      onChangeQuestion={onChangeQuestion} />
    <LocalizationPanel
      node={node}
      localizationChanged={questionLocalizationChanged}
      header={t('target.editor.button.addQuestionLocalisation')}
      localizationIndex={0}
    />
    <label>{t('target.editor.label.skipButton')}</label>
    <input type="checkbox" data-redisid="skipbutton"
      title={t('target.editor.label.skipButton')}
      checked={skipButton}
      onChange={onToggleSkipButton}
    />
  </fieldset>
);

export default withTranslation('common')(QuestionPanel);
